/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MessageTemplateKind = {
    Text: 'TEXT',
    RequestLocation: 'REQUEST_LOCATION'
} as const;
export type MessageTemplateKind = typeof MessageTemplateKind[keyof typeof MessageTemplateKind];


export function instanceOfMessageTemplateKind(value: any): boolean {
    for (const key in MessageTemplateKind) {
        if (Object.prototype.hasOwnProperty.call(MessageTemplateKind, key)) {
            if (MessageTemplateKind[key as keyof typeof MessageTemplateKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MessageTemplateKindFromJSON(json: any): MessageTemplateKind {
    return MessageTemplateKindFromJSONTyped(json, false);
}

export function MessageTemplateKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageTemplateKind {
    return json as MessageTemplateKind;
}

export function MessageTemplateKindToJSON(value?: MessageTemplateKind | null): any {
    return value as any;
}

export function MessageTemplateKindToJSONTyped(value: any, ignoreDiscriminator: boolean): MessageTemplateKind {
    return value as MessageTemplateKind;
}

